export const    REPAIR = 'REPAIR';
export const    REPAIR_SUCCESS = 'REPAIR_SUCCESS';
export const    REPAIR_OPEN_SUCCESS = 'REPAIR_OPEN_SUCCESS';
export const    REPAIR_CLOSE_SUCCESS = 'REPAIR_CLOSE_SUCCESS';
export const    REPAIR_ERROR = 'REPAIR_ERROR';

export const REPAIRS_FILTERS = 'REPAIRS_FILTERS';
export const REPAIRS_FILTERS_SUCCESS = 'REPAIRS_FILTERS_SUCCESS';
export const REPAIRS_FILTERS_ERROR = 'REPAIRS_FILTERS_ERROR';



export const    ADD_REPAIR = 'ADD_REPAIR';
export const    ADD_REPAIR_SUCCESS = 'ADD_REPAIR_SUCCESS';
export const    ADD_REPAIR_ERROR = 'ADD_REPAIR_ERROR';

export const    UPDATE_REPAIR = 'UPDATE_REPAIR';
export const    UPDATE_REPAIR_SUCCESS = 'UPDATE_REPAIR_SUCCESS';
export const    UPDATE_REPAIR_ERROR = 'UPDATE_REPAIR_ERROR';


export const DELETE_REPAIR = 'DELETE_REPAIR';
export const DELETE_REPAIR_SUCCESS= 'DELETE_REPAIR_SUCCESS';
export const DELETE_REPAIR_ERROR ='DELETE_REPAIR_ERROR';

export const ADD_VIEW_REPAIR = 'ADD_VIEW_REPAIR';
export const ADD_VIEW_REPAIR_SUCCESS= 'ADD_VIEW_REPAIR_SUCCESS';
export const ADD_VIEW_REPAIR_ERROR ='ADD_VIEW_REPAIR_ERROR';


export const CLOSE_REPAIR = 'CLOSE_REPAIR';
export const CLOSE_REPAIR_SUCCESS= 'CLOSE_REPAIR_SUCCESS';
export const CLOSE_REPAIR_ERROR ='CLOSE_REPAIR_ERROR';

export const CANCEL_REPAIR = 'CANCEL_REPAIR';
export const CANCEL_REPAIR_SUCCESS= 'CANCEL_REPAIR_SUCCESS';
export const CANCEL_REPAIR_ERROR ='CANCEL_REPAIR_ERROR';

//New constanst for historic dashboard
export const HISTORIC_DASHBOARD_REPAIR='HISTORIC_DASHBOARD_REPAIR';
export const HISTORIC_DASHBOARD_REPAIR_SUCCESS='HISTORIC_DASHBOARD_REPAIR_SUCCESS';
export const HISTORIC_DASHBOARD_REPAIR_ERROR='HISTORIC_DASHBOARD_REPAIR_ERROR';

export const REPAIR_OPEN_ERROR = 'REPAIR_OPEN_ERROR';
export const REPAIR_CLOSE_ERROR = 'REPAIR_CLOSE_ERROR';


